import { normalizeDocument } from "../model/documentModel";

export const NEWSLETTER_EDITOR_SESSION_KEY = "newsletter_editor_session";

export const saveEditorSession = (session) => {
  if (!session?.workspaceActive) {
    sessionStorage.removeItem(NEWSLETTER_EDITOR_SESSION_KEY);
    return;
  }
  sessionStorage.setItem(
    NEWSLETTER_EDITOR_SESSION_KEY,
    JSON.stringify({
      document: session.document,
      savedObjectKey: session.savedObjectKey ?? null,
      dirty: Boolean(session.dirty),
      workspaceActive: true,
    })
  );
};

export const loadEditorSession = () => {
  const raw = sessionStorage.getItem(NEWSLETTER_EDITOR_SESSION_KEY);
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw);
    if (!parsed?.workspaceActive || !parsed.document) {
      return null;
    }
    return {
      document: normalizeDocument(parsed.document),
      savedObjectKey: parsed.savedObjectKey ?? null,
      dirty: Boolean(parsed.dirty),
      workspaceActive: true,
    };
  } catch {
    sessionStorage.removeItem(NEWSLETTER_EDITOR_SESSION_KEY);
    return null;
  }
};

export const clearEditorSession = () => {
  sessionStorage.removeItem(NEWSLETTER_EDITOR_SESSION_KEY);
};
 